import { render } from "./UtamaView.vue?vue&type=template&id=0f29eb02"
import script from "./UtamaView.vue?vue&type=script&lang=js"
export * from "./UtamaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__